define('home/templates/channelGroupFeeds',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<ul class=\"list--inline text-center text-medium border-bottom\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.tabs : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</ul>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<li data-action=\"switch-tab\" data-tab=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" class=\"nav-bar__item\">\n<a href=\"/home/explore/"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depths[1] != null ? depths[1].exploreTab : depths[1]),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(5, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "/"
    + alias2(alias1(((stack1 = (depths[1] != null ? depths[1].channel : depths[1])) != null ? stack1.slug : stack1), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "/\" class=\"nav-bar__link\">\n<strong>"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</strong>\n</a>\n</li>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    return container.escapeExpression(container.lambda((depths[1] != null ? depths[1].exploreTab : depths[1]), depth0));
},"5":function(container,depth0,helpers,partials,data) {
    return "channels";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return ((stack1 = helpers["if"].call(alias1,helpers.gt.call(alias1,(depth0 != null ? depth0.numTabs : depth0),1,{"name":"gt","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div data-role=\"content-area\"></div>\n";
},"useData":true,"useDepths":true})

});
